import React from "react";

function Iphone() {
  return (
    <div>
      <h1 className="center">Iphone page</h1>
    </div>
  );
}

export default Iphone;
